/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/admin/announcements\",\"regex\":\"^/([^/]+)/admin/announcements$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/admin/emails\",\"regex\":\"^/([^/]+)/admin/emails$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/admin/feature-flags\",\"regex\":\"^/([^/]+)/admin/feature-flags$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/admin/fxa\",\"regex\":\"^/([^/]+)/admin/fxa$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/admin/qa-customs\",\"regex\":\"^/([^/]+)/admin/qa-customs$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/dashboard/:slug*?\",\"regex\":\"^/([^/]+)/user/dashboard(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/dashboard/fix\",\"regex\":\"^/([^/]+)/user/dashboard/fix$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/dashboard/fix/high-risk-data-breaches\",\"regex\":\"^/([^/]+)/user/dashboard/fix/high-risk-data-breaches$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/dashboard/fix/high-risk-data-breaches/:type\",\"regex\":\"^/([^/]+)/user/dashboard/fix/high-risk-data-breaches/([^/]+)$\",\"paramNames\":[\"locale\",\"type\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/dashboard/fix/leaked-passwords/:type\",\"regex\":\"^/([^/]+)/user/dashboard/fix/leaked-passwords/([^/]+)$\",\"paramNames\":[\"locale\",\"type\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/dashboard/fix/security-recommendations/:type\",\"regex\":\"^/([^/]+)/user/dashboard/fix/security-recommendations/([^/]+)$\",\"paramNames\":[\"locale\",\"type\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/user/settings/:slug*?\",\"regex\":\"^/([^/]+)/user/settings(?:/(.*))?$\",\"paramNames\":[\"locale\",\"slug\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/breach-details/:breachName\",\"regex\":\"^/([^/]+)/breach-details/([^/]+)$\",\"paramNames\":[\"locale\",\"breachName\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/breaches\",\"regex\":\"^/([^/]+)/breaches$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/how-it-works\",\"regex\":\"^/([^/]+)/how-it-works$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/unsubscribe/breach-alerts\",\"regex\":\"^/([^/]+)/unsubscribe/breach-alerts$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/auth/logout\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.0";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  environment: getEnvironment(),
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: ["local"].includes(getEnvironment()) ? 1.0 : 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: getEnvironment() !== "production",

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: ["local", "heroku"].includes(getEnvironment())
    ? 1.0
    : 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: getEnvironment() === "local",
      blockAllMedia: getEnvironment() === "local",
    }),
    Sentry.browserTracingIntegration(),
  ],
});

/**
 * We use the same built artifacts in every environment. Since client-side
 * environment variables get compiled in at build time, the only environment
 * variables that are available are the ones that are available on the build
 * server, which therefore do not necessarily represent the environment the code
 * will eventually run in. Therefore, we have to dynamically determine the
 * environment at runtime, which is what this function does.
 */
function getEnvironment() {
  if (
    document.location.origin === "https://monitor.firefox.com" ||
    document.location.origin === "https://monitor.mozilla.com" ||
    document.location.origin === "https://monitor.mozilla.org"
  ) {
    return "production";
  }
  if (document.location.origin === "https://monitor-stage.allizom.org") {
    return "stage";
  }
  if (document.location.origin === "https://fx-breach-alerts.herokuapp.com") {
    return "heroku";
  }
  if (document.location.hostname === "localhost") {
    return "local";
  }

  return "unknown";
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
